import mutations from "./mutations";
import getters from "./getters";
import actions from "./actions";

const state = {
    weightAdjustment: {
        adjustment: 0 ,
        ticker: null,
        batchIds: []
    }
}



export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
